import common from "../common";
import Scene from "./Scene";
import {isCordova, translate} from "../utils";
import SceneTitlePanel from "../ui/SceneTitlePanel";
import MenuBackground from "../ui/MenuBackground";
import Snapshot from "../ui/Snapshot";

export default class MenuScene extends Scene {

    constructor() {
        super();
        this._scrollSpeed = -15;
    }

    init() {
        super.init();

        this._bg = new PIXI.TilingSprite(P3.assets.texture("bg_main"), common.STAGE_WIDTH, common.STAGE_HEIGHT);
        this.addChild(this._bg);

        this._bg.tilePosition = common.tilePosition;

        this._bgDeco = new MenuBackground();
        this._bgDeco.position.set(common.STAGE_WIDTH / 2, common.STAGE_HEIGHT / 2);
        this.addChild(this._bgDeco);

        this._sceneTitle = new SceneTitlePanel(translate("how_to"));
        this._sceneTitle.position.set(common.STAGE_WIDTH / 2, 90);
        this.addChild(this._sceneTitle);

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_lozenge_out");
        states.down = P3.assets.texture("btn_primary_lozenge_down");
        states.over = P3.assets.texture("btn_primary_lozenge_over");

        const style = new PIXI.TextStyle({
            dropShadow: true,
            dropShadowAngle: -4.3,
            dropShadowColor: "#353535",
            dropShadowDistance: 5,
            fill: 0xffffff,
            fontFamily: "LuckiestGuy",
            fontSize: 50,
            letterSpacing: 6,
            lineJoin: "round"
        });

        this._drawButton = new P3.Button(states);
        this._drawButton.label = new PIXI.Text(translate("draw_menu"), style);
        this._drawButton.label.anchor.set(0.5);
        this._drawButton.label.position.set(40, -5);
        this._drawButton.animation.addChild(this._drawButton.label);
        this._drawButton.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 - 60);
        this._drawButton.signals.click.once(this._onDrawClick, this);
        this._drawButton.clickSoundName = "sfx_click";
        //this._drawButton.overSoundName = "sfx_rollover";
        this.addChild(this._drawButton);

        const pencilIcon = new PIXI.Sprite(P3.assets.texture("icon_pencil"));
        pencilIcon.anchor.set(0.5);
        pencilIcon.position.set(-90, 0);
        this._drawButton.animation.addChild(pencilIcon);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_lozenge_out");
        states.down = P3.assets.texture("btn_primary_lozenge_down");
        states.over = P3.assets.texture("btn_primary_lozenge_over");

        this._viewButton = new P3.Button(states);
        this._viewButton.label = new PIXI.Text(translate("view_menu"), style);
        this._viewButton.label.anchor.set(0.5);
        this._viewButton.label.position.set(40, -5);
        this._viewButton.animation.addChild(this._viewButton.label);
        this._viewButton.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 + 60);
        this._viewButton.signals.click.once(this._onViewClick, this);
        this._viewButton.clickSoundName = "sfx_click";
        //this._viewButton.overSoundName = "sfx_rollover";
        this.addChild(this._viewButton);

        const pictureIcon = new PIXI.Sprite(P3.assets.texture("icon_painting"));
        pictureIcon.anchor.set(0.5);
        pictureIcon.position.set(-90, 0);
        this._viewButton.animation.addChild(pictureIcon);

        this._learnButton = new P3.Button(states);
        this._learnButton.label = new PIXI.Text("LEARN", style);
        this._learnButton.label.anchor.set(0.5);
        this._learnButton.animation.addChild(this._learnButton.label);
        this._learnButton.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this._learnButton.signals.click.once(this._onLearnClick, this);
        this._learnButton.enabled = false;
        this._learnButton.renderable = false;
        this._learnButton.interactive = false;
        this.addChild(this._learnButton);

        states = new P3.ButtonStates();

        states.normal = P3.assets.texture("btn_primary_small_out");
        states.over = P3.assets.texture("btn_primary_small_over");
        states.down = P3.assets.texture("btn_primary_small_down");
        states.icon = P3.assets.texture("icon_settings");

        this._configButton = new P3.Button(states);
        this._configButton.signals.click.add(this._onConfigButtonClick, this);
        this._configButton.clickSoundName = "sfx_click";
        this._configButton.overSoundName = "sfx_rollover";
        this.addChild(this._configButton);

        const uiElements = [this._sceneTitle, this._drawButton, this._viewButton, this._learnButton, this._configButton];

        for (let i = 0; i < uiElements.length; i++) {
            const e = uiElements[i];
            e.visible = false;
        }

        /*
        const sprite = new PIXI.Sprite(P3.assets.texture("game_image_ttg"));
        this.addChild(sprite);
        this._snapshot = new Snapshot();
        this._snapshot.saveToFileSystem(sprite, () => {
            alert("success");
        })

         */
    }

    resize() {
        super.resize();
        this._configButton.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 - 90, 90);
    }

    animateIn() {
        const uiElements = [this._sceneTitle, this._drawButton, this._viewButton, this._learnButton, this._configButton];

        for (let i = 0; i < uiElements.length; i++) {
            const e = uiElements[i];
            e.scale.set(0.3);

            new P3.utils.TWEEN.Tween(e.scale, this._tweens)
                .delay(i * 200 + 200)
                .to({x: 1, y: 1}, 520)
                .easing(P3.utils.TWEEN.Easing.Back.Out)
                .onStart(() => e.visible = true)
                .start();
        }

        this._bgDeco.animateIn();
    }

    destroy() {
        // clean up goes here
        super.destroy();
    }

    update(dt = window.deltaTime) {
        super.update();
        common.tilePosition.x += this._scrollSpeed * dt;
        common.tilePosition.y -= this._scrollSpeed * dt;

        if (common.tilePosition.x < 0) {
            common.tilePosition.x = common.STAGE_WIDTH;
        }
        if (common.tilePosition.y > common.STAGE_HEIGHT) {
            common.tilePosition.y = 0;
        }

        this._bg.tilePosition = common.tilePosition.clone();
        this._bgDeco.update();
    }

    end() {
        // this.signals.next.dispatch();
    }

    _onPlayButtonClick() {
        //window.open(this._carousel.selected.url, randomSeed());
        //window.open(this._carousel.selected.url, "_blank");
    }

    _onDrawClick() {
        this.signals.next.dispatch();
    }

    _onViewClick() {
        this.signals.previous.dispatch();
    }

    _onLearnClick() {
        this.signals.home.dispatch();
    }

    _onConfigButtonClick() {
        this.signals.settings.dispatch();
    }
}